export const ROOT_PATH = "/";

export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;

// products
export const PRODUCT_LIST_PATH = `${ROOT_PATH}product-list`;
export const ADD_PRODUCT_PATH = `${ROOT_PATH}add-product`;
export const EDIT_PRODUCT_PATH = `${ROOT_PATH}edit-product`;
export const DETAILS_PRODUCT_PATH = `${ROOT_PATH}product-details`;

// stores
export const STORE_LIST_PATH = `${ROOT_PATH}store-list`;
export const ADD_STORE_PATH = `${ROOT_PATH}add-store`;
export const EDIT_STORE_PATH = `${ROOT_PATH}edit-store`;

// generic
export const GENERIC_LIST_PATH = `${ROOT_PATH}generic-list`;
export const ADD_GENERIC_PATH = `${ROOT_PATH}add-generic`;
export const EDIT_GENERIC_PATH = `${ROOT_PATH}edit-generic`;

// customer
export const CUSTOMER_LIST_PATH = `${ROOT_PATH}customer-list`;
export const ADD_CUSTOMER_PATH = `${ROOT_PATH}add-customer`;
export const EDIT_CUSTOMER_PATH = `${ROOT_PATH}edit-customer`;

// customer transaction
export const CUSTOMER_TRANSACTION_LIST_PATH = `${ROOT_PATH}customer-transaction-list`;
export const ADD_CUSTOMER_TRANSACTION_PATH = `${ROOT_PATH}add-customer-transaction`;
export const EDIT_CUSTOMER_TRANSACTION_PATH = `${ROOT_PATH}edit-customer-transaction`;

// supplier
export const SUPPLIER_LIST_PATH = `${ROOT_PATH}supplier-list`;
export const ADD_SUPPLIER_PATH = `${ROOT_PATH}add-supplier`;
export const EDIT_SUPPLIER_PATH = `${ROOT_PATH}edit-supplier`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;

// suit
export const SUIT_LIST_PATH = `${ROOT_PATH}suit-list`;
export const ADD_SUIT_PATH = `${ROOT_PATH}add-suit`;
export const EDIT_SUIT_PATH = `${ROOT_PATH}edit-suit`;

// banner
export const BANNER_LIST_PATH = `${ROOT_PATH}banner-list`;
export const ADD_BANNER_PATH = `${ROOT_PATH}add-banner`;
export const EDIT_BANNER_PATH = `${ROOT_PATH}edit-banner`;

// company
export const COMPANY_LIST_PATH = `${ROOT_PATH}company-list`;
export const ADD_COMPANY_PATH = `${ROOT_PATH}add-company`;
export const EDIT_COMPANY_PATH = `${ROOT_PATH}edit-company`;

// faq
export const FAQ_LIST_PATH = `${ROOT_PATH}faq-list`;
export const ADD_FAQ_PATH = `${ROOT_PATH}add-faq`;
export const EDIT_FAQ_PATH = `${ROOT_PATH}edit-faq`;

// service
export const SERVICE_LIST_PATH = `${ROOT_PATH}service-list`;
export const ADD_SERVICE_PATH = `${ROOT_PATH}add-service`;
export const EDIT_SERVICE_PATH = `${ROOT_PATH}edit-service`;

// Gallery
export const GALLERY_LIST_PATH = `${ROOT_PATH}gallery-list`;
export const ADD_GALLERY_PATH = `${ROOT_PATH}add-gallery`;
export const EDIT_GALLERY_PATH = `${ROOT_PATH}edit-gallery`;

// testimonial
export const TESTIMONIAL_LIST_PATH = `${ROOT_PATH}testimonial-list`;
export const ADD_TESTIMONIAL_PATH = `${ROOT_PATH}add-testimonial`;
export const EDIT_TESTIMONIAL_PATH = `${ROOT_PATH}edit-testimonial`;

// job
export const JOB_LIST_PATH = `${ROOT_PATH}job-list`;
export const ADD_JOB_PATH = `${ROOT_PATH}add-job`;
export const EDIT_JOB_PATH = `${ROOT_PATH}edit-job`;

// team member
export const TEAM_MEMBER_LIST_PATH = `${ROOT_PATH}team-member-list`;
export const ADD_TEAM_MEMBER_PATH = `${ROOT_PATH}add-team-member`;
export const EDIT_TEAM_MEMBER_PATH = `${ROOT_PATH}edit-team-member`;

// tribute
export const TRIBUTE_LIST_PATH = `${ROOT_PATH}tribute-list`;
export const ADD_TRIBUTE_PATH = `${ROOT_PATH}add-tribute`;
export const EDIT_TRIBUTE_PATH = `${ROOT_PATH}edit-tribute`;

// Activity
export const ACTIVITY_LIST_PATH = `${ROOT_PATH}activity-list`;
export const ADD_ACTIVITY_PATH = `${ROOT_PATH}add-activity`;
export const EDIT_ACTIVITY_PATH = `${ROOT_PATH}edit-activity`;

// Complimentary
export const COMPLIMENTARY_LIST_PATH = `${ROOT_PATH}complimentary-list`;
export const ADD_COMPLIMENTARY_PATH = `${ROOT_PATH}add-complimentary`;
export const EDIT_COMPLIMENTARY_PATH = `${ROOT_PATH}edit-complimentary`;

// Accommodation
export const ACCOMMODATION_LIST_PATH = `${ROOT_PATH}accommodation-list`;
export const ADD_ACCOMMODATION_PATH = `${ROOT_PATH}add-accommodation`;
export const EDIT_ACCOMMODATION_PATH = `${ROOT_PATH}edit-accommodation`;

// sale
export const SALE_LIST_PATH = `${ROOT_PATH}sale-list`;
export const ADD_SALE_PATH = `${ROOT_PATH}add-sale`;
export const EDIT_SALE_PATH = `${ROOT_PATH}edit-sale`;
export const SALE_RECORD_PATH = `${ROOT_PATH}sale-record`;
export const SALE_DETAILS_PATH = `${ROOT_PATH}sale-details`;

// purchase
export const SALE_PURCHASE_PATH = `${ROOT_PATH}purchase-list`;
export const ADD_PURCHASE_PATH = `${ROOT_PATH}add-purchase`;
export const EDIT_PURCHASE_PATH = `${ROOT_PATH}edit-purchase`;
export const PURCHASE_RECORD_PATH = `${ROOT_PATH}purchase-record`;
export const PURCHASE_DETAILS_PATH = `${ROOT_PATH}purchase-details`;

// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// business
export const BUSINESS_LIST_PATH = `${ROOT_PATH}business-list`;
export const ADD_BUSINESS_PATH = `${ROOT_PATH}add-business`;
export const EDIT_BUSINESS_PATH = `${ROOT_PATH}edit-business`;

// philanthropic
export const PHILANTHROPIC_LIST_PATH = `${ROOT_PATH}philanthropic-list`;
export const ADD_PHILANTHROPIC_PATH = `${ROOT_PATH}add-philanthropic`;
export const EDIT_PHILANTHROPIC_PATH = `${ROOT_PATH}edit-philanthropic`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// recent-work
export const RECENT_WORK_LIST_PATH = `${ROOT_PATH}recent-work-list`;
export const ADD_RECENT_WORK_PATH = `${ROOT_PATH}add-recent-work`;
export const EDIT_RECENT_WORK_PATH = `${ROOT_PATH}edit-recent-work`;

// customer feedback
export const CUSTOMER_FEEDBACK_LIST_PATH = `${ROOT_PATH}customer-feedback-list`;

// contact
export const CONTACT_LIST_PATH = `${ROOT_PATH}contact-list`;

// site config
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// promotion
export const PROMOTION_LIST_PATH = `${ROOT_PATH}promotion-list`;
export const ADD_PROMOTION_PATH = `${ROOT_PATH}add-promotion`;
export const EDIT_PROMOTION_PATH = `${ROOT_PATH}edit-promotion`;

// blog
export const BLOG_LIST_PATH = `${ROOT_PATH}blog-list`;
export const ADD_BLOG_PATH = `${ROOT_PATH}add-blog`;
export const EDIT_BLOG_PATH = `${ROOT_PATH}edit-blog`;

// package
export const PACKAGE_LIST_PATH = `${ROOT_PATH}package-list`;
export const ADD_PACKAGE_PATH = `${ROOT_PATH}add-package`;
export const EDIT_PACKAGE_PATH = `${ROOT_PATH}edit-package`;

// page not found
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// Booking
export const BOOKING_LIST_PATH = `${ROOT_PATH}booking`;
export const EDIT_BOOKING_PATH = `${ROOT_PATH}edit-booking`;
export const BOOKING_DETAILS_PATH = `${ROOT_PATH}booking-details`;

// order
export const ORDER_LIST_PATH = `${ROOT_PATH}order-list`;
export const ADD_ORDER_PATH = `${ROOT_PATH}add-order`;
export const EDIT_ORDER_PATH = `${ROOT_PATH}edit-order`;

// payment
export const PAYMENT_LIST_PATH = `${ROOT_PATH}payment-list`;
export const ADD_PAYMENT_PATH = `${ROOT_PATH}add-payment`;
export const EDIT_PAYMENT_PATH = `${ROOT_PATH}edit-payment`;

// lead
export const LEAD_LIST_PATH = `${ROOT_PATH}lead-list`;
export const ADD_LEAD_PATH = `${ROOT_PATH}add-lead`;
export const EDIT_LEAD_PATH = `${ROOT_PATH}edit-lead`;

// gymBanner
export const GYMBANNER_LIST_PATH = `${ROOT_PATH}gymBanner-list`;
export const ADD_GYMBANNER_PATH = `${ROOT_PATH}add-gymBanner`;
export const EDIT_GYMBANNER_PATH = `${ROOT_PATH}edit-gymBanner`;

// gymClient
export const GYMCLIENT_LIST_PATH = `${ROOT_PATH}gymClient-list`;
export const ADD_GYMCLIENT_PATH = `${ROOT_PATH}add-gymClient`;
export const EDIT_GYMCLIENT_PATH = `${ROOT_PATH}edit-gymClient`;

// gymContact
export const GYMCONTACT_LIST_PATH = `${ROOT_PATH}gymContact-list`;
export const ADD_GYMCONTACT_PATH = `${ROOT_PATH}add-gymContact`;
export const EDIT_GYMCONTACT_PATH = `${ROOT_PATH}edit-gymContact`;

// gymFeature
export const GYMFEATURE_LIST_PATH = `${ROOT_PATH}gymFeature-list`;
export const ADD_GYMFEATURE_PATH = `${ROOT_PATH}add-gymFeature`;
export const EDIT_GYMFEATURE_PATH = `${ROOT_PATH}edit-gymFeature`;

// gymScreen
export const GYMSCREEN_LIST_PATH = `${ROOT_PATH}gymScreen-list`;
export const ADD_GYMSCREEN_PATH = `${ROOT_PATH}add-gymScreen`;
export const EDIT_GYMSCREEN_PATH = `${ROOT_PATH}edit-gymScreen`;

// gymSiteConfig
export const GYMSITECONFIG_LIST_PATH = `${ROOT_PATH}gymSiteConfig-list`;
export const ADD_GYMSITECONFIG_PATH = `${ROOT_PATH}add-gymSiteConfig`;
export const EDIT_GYMSITECONFIG_PATH = `${ROOT_PATH}edit-gymSiteConfig`;

// gymStaticPage
export const GYMSTATICPAGE_LIST_PATH = `${ROOT_PATH}gymStaticPage-list`;
export const ADD_GYMSTATICPAGE_PATH = `${ROOT_PATH}add-gymStaticPage`;
export const EDIT_GYMSTATICPAGE_PATH = `${ROOT_PATH}edit-gymStaticPage`;

// gymWhyChooseUs
export const GYMWHYCHOOSEUS_LIST_PATH = `${ROOT_PATH}gymWhyChooseUs-list`;
export const ADD_GYMWHYCHOOSEUS_PATH = `${ROOT_PATH}add-gymWhyChooseUs`;
export const EDIT_GYMWHYCHOOSEUS_PATH = `${ROOT_PATH}edit-gymWhyChooseUs`;

// gymGallery
export const GYMGALLERY_LIST_PATH = `${ROOT_PATH}gymGallery-list`;
export const ADD_GYMGALLERY_PATH = `${ROOT_PATH}add-gymGallery`;
export const EDIT_GYMGALLERY_PATH = `${ROOT_PATH}edit-gymGallery`;

// gymVideos
export const GYMVIDEOS_LIST_PATH = `${ROOT_PATH}gymVideos-list`;
export const ADD_GYMVIDEOS_PATH = `${ROOT_PATH}add-gymVideos`;
export const EDIT_GYMVIDEOS_PATH = `${ROOT_PATH}edit-gymVideos`;

// urelaaProductionServices
export const URELAAPRODUCTIONSERVICES_LIST_PATH = `${ROOT_PATH}urelaaProductionServices-list`;
export const ADD_URELAAPRODUCTIONSERVICES_PATH = `${ROOT_PATH}add-urelaaProductionServices`;
export const EDIT_URELAAPRODUCTIONSERVICES_PATH = `${ROOT_PATH}edit-urelaaProductionServices`;

// urelaaProductionCategories
export const URELAAPRODUCTIONCATEGORIES_LIST_PATH = `${ROOT_PATH}urelaaProductionCategories-list`;
export const ADD_URELAAPRODUCTIONCATEGORIES_PATH = `${ROOT_PATH}add-urelaaProductionCategories`;
export const EDIT_URELAAPRODUCTIONCATEGORIES_PATH = `${ROOT_PATH}edit-urelaaProductionCategories`;

// urelaaProductionBanners
export const URELAAPRODUCTIONBANNERS_LIST_PATH = `${ROOT_PATH}urelaaProductionBanners-list`;
export const ADD_URELAAPRODUCTIONBANNERS_PATH = `${ROOT_PATH}add-urelaaProductionBanners`;
export const EDIT_URELAAPRODUCTIONBANNERS_PATH = `${ROOT_PATH}edit-urelaaProductionBanners`;

// urelaaProductionCustomerFeedback
export const URELAAPRODUCTIONCUSTOMERFEEDBACK_LIST_PATH = `${ROOT_PATH}urelaaProductionCustomerFeedback-list`;
export const ADD_URELAAPRODUCTIONCUSTOMERFEEDBACK_PATH = `${ROOT_PATH}add-urelaaProductionCustomerFeedback`;
export const EDIT_URELAAPRODUCTIONCUSTOMERFEEDBACK_PATH = `${ROOT_PATH}edit-urelaaProductionCustomerFeedback`;

// urelaaProductionServicePricing
export const URELAAPRODUCTIONSERVICEPRICING_LIST_PATH = `${ROOT_PATH}urelaaProductionServicePricing-list`;
export const ADD_URELAAPRODUCTIONSERVICEPRICING_PATH = `${ROOT_PATH}add-urelaaProductionServicePricing`;
export const EDIT_URELAAPRODUCTIONSERVICEPRICING_PATH = `${ROOT_PATH}edit-urelaaProductionServicePricing`;
// expense

export const EXPENSE_LIST_PATH = `${ROOT_PATH}expense-list`;
export const ADD_EXPENSE_PATH = `${ROOT_PATH}add-expense`;
export const EDIT_EXPENSE_PATH = `${ROOT_PATH}edit-expense`;
// openingBalance
export const OPENING_BALANCE_LIST_PATH = `${ROOT_PATH}opening-balance-list`;
export const ADD_OPENING_BALANCE_PATH = `${ROOT_PATH}add-opening-balance`;
export const EDIT_OPENING_BALANCE_PATH = `${ROOT_PATH}edit-opening-balance`;

// monthTarget
export const MONTH_TARGET_LIST_PATH = `${ROOT_PATH}month-target-list`;
export const ADD_MONTH_TARGET_PATH = `${ROOT_PATH}add-month-target`;
export const EDIT_MONTH_TARGET_PATH = `${ROOT_PATH}edit-month-target`;

// dashboard
export const DASHBOARD_PATH = `${ROOT_PATH}dashboard`;

// SLUGS_EXPORTS_AREA
